// extracted by mini-css-extract-plugin
export default {"header":"header_header__b-VSt","wrapper":"header_wrapper__o9QzF","hoverText":"header_hoverText__IX5Bk"};